export interface Job {
  id: number;
  facilityType: string;
  monthlyIncome: string;
  overtime?: string;
  departments: string;
  location: string;
  tags: string[];
  badge?: string;
  accentType: 'hospital' | 'clinic' | 'homecare' | 'rehab';
}

export const JOBS: Job[] = [
  {
    id: 8,
    facilityType: '企業（産業看護師）',
    monthlyIncome: '83万円〜',
    departments: '企業内看護業務',
    location: '東京都',
    tags: ['土日祝休み', '年間休日120日'],
    badge: '人気No.1',
    accentType: 'rehab',
  },
  {
    id: 2,
    facilityType: '訪問看護ステーション',
    monthlyIncome: '60万円〜',
    departments: '訪問看護',
    location: '東京都 西東京市',
    tags: ['賞与実績あり', '年間休日120日', '駅チカ徒歩5分'],
    badge: '注目',
    accentType: 'homecare',
  },
  {
    id: 7,
    facilityType: '精神科訪問看護',
    monthlyIncome: '60万円〜',
    departments: '精神科訪問看護',
    location: '東京都',
    tags: ['土日祝休み', '未経験・ブランクOK', '年間休日125日'],
    badge: 'NEW',
    accentType: 'homecare',
  },
  {
    id: 1,
    facilityType: 'クリニック（マネジメント業務）',
    monthlyIncome: '58万円〜',
    departments: 'マネジメント業務',
    location: '東京都 中央区',
    tags: ['賞与実績あり', '年間休日120日'],
    badge: '注目',
    accentType: 'clinic',
  },
  {
    id: 9,
    facilityType: 'クリニック',
    monthlyIncome: '52万円〜',
    departments: 'クリニック看護業務',
    location: '埼玉県',
    tags: ['土日祝休み', '年間休日120日', '駅チカ'],
    accentType: 'clinic',
  },
  {
    id: 6,
    facilityType: '美容クリニック',
    monthlyIncome: '50万円〜',
    departments: '美容クリニック看護業務',
    location: '東京都',
    tags: ['残業なし', '土日祝休み', '月給50万円以上可', '年間休日120日'],
    badge: 'NEW',
    accentType: 'clinic',
  },
  {
    id: 5,
    facilityType: '訪問看護ステーション',
    monthlyIncome: '46万円〜',
    departments: '訪問看護',
    location: '神奈川県',
    tags: ['賞与あり', '年間休日120日'],
    accentType: 'homecare',
  },
  {
    id: 4,
    facilityType: 'デンタルクリニック',
    monthlyIncome: '42万円〜',
    departments: 'デンタルクリニック看護業務',
    location: '東京都 立川市',
    tags: ['年間休日120日'],
    accentType: 'clinic',
  },
  {
    id: 3,
    facilityType: 'クリニック',
    monthlyIncome: '41.7万円〜',
    departments: 'クリニック看護業務',
    location: '東京都 渋谷区',
    tags: ['賞与1.2ヶ月分', '年間休日126日'],
    accentType: 'clinic',
  },
  {
    id: 11,
    facilityType: '美容外科クリニック',
    monthlyIncome: '40.9万円〜',
    departments: '施術補助・医療脱毛・美容点滴・患者様対応',
    location: '全国多数拠点あり',
    tags: ['年間休日120日以上', '美容未経験OK', 'インセンティブあり', '社割あり', '研修充実'],
    accentType: 'clinic',
  },
  {
    id: 12,
    facilityType: '美容皮膚科クリニック',
    monthlyIncome: '35〜50万円',
    overtime: '月平均5時間',
    departments: 'ピコトーニング・フォトフェイシャル・ダーマペン・医療脱毛・ハイフ等',
    location: '東京都 千代田区',
    tags: ['年間休日116日', '残業月5時間', 'ブランク可', '第二新卒可', '有給取得率80%', '駅チカ徒歩3分'],
    accentType: 'clinic',
  },
  {
    id: 10,
    facilityType: '男性専門美容クリニック',
    monthlyIncome: '33〜50万円',
    overtime: '月平均15時間',
    departments: 'オペ介助・医療脱毛・美容皮膚科施術・術後ケア',
    location: '東京都 中央区',
    tags: ['賞与年2回', '年間休日120日', 'オープニングスタッフ', '駅チカ徒歩1分'],
    accentType: 'clinic',
  },
];
